import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Stop } from './stop.model';

export interface StopState extends EntityState<Stop, Stop['id']>, ActiveState<Stop> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'stop', resettable: true, idKey: 'id' })
export class StopStore extends EntityStore<StopState> {
  constructor() {
    super();
  }

  override akitaPreAddEntity(entity: Stop) {
    return {
      ...entity,
      toDate: entity.toDate ? new Date(entity.toDate) : undefined,
      fromDate: entity.fromDate ? new Date(entity.fromDate) : undefined,
    };
  }
}
